document.addEventListener('DOMContentLoaded', function() {
  function debounce(fn, delay) {
    let timer;
    return function() {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }

  const initCarousels = function() {
    if (typeof EmblaCarousel === 'undefined') return;

    const carousels$ = document.querySelectorAll('.collections-carousel');

    carousels$.forEach(function(carousel$) {
      if (carousel$.dataset.initialized === 'true') return;

      const viewport$ = carousel$.querySelector('.carousel-viewport');
      const prevButton$ = carousel$.querySelector('.carousel-arrow-prev');
      const nextButton$ = carousel$.querySelector('.carousel-arrow-next');

      if (!viewport$) return;

      carousel$.dataset.initialized = 'true';

      const slides$ = carousel$.querySelectorAll('.carousel-slide');
      const gap = parseInt(getComputedStyle(carousel$).getPropertyValue('--carousel-gap')) || 5;

      const getSlidesPerView = function() {
        return window.innerWidth >= 750 ? 4 : 2.5;
      };

      const calculateSlideWidth = function() {
        const slidesPerView = getSlidesPerView();
        const totalGap = gap * (slidesPerView - 1);
        return (viewport$.offsetWidth - totalGap) / slidesPerView;
      };

      const setSlideWidths = function() {
        const slideWidth = calculateSlideWidth();
        slides$.forEach(function(slide$) {
          slide$.style.flex = '0 0 ' + slideWidth + 'px';
          slide$.style.minWidth = slideWidth + 'px';
          slide$.style.marginRight = gap + 'px';
        });
      };

      const getEmblaOptions = function() {
        const isMobile = window.innerWidth < 750;
        const wrapper$ = carousel$.querySelector('.carousel-wrapper');
        const isStatic = (isMobile && wrapper$ && wrapper$.classList.contains('mobile-static')) ||
                         (!isMobile && wrapper$ && wrapper$.classList.contains('desktop-static'));

        return {
          loop: !isStatic,
          align: 'start',
          slidesToScroll: 1,
          containScroll: false,
          watchDrag: !isStatic,
          active: !isStatic
        };
      };

      setSlideWidths();

      const embla = EmblaCarousel(viewport$, getEmblaOptions());

      const handleResize = debounce(function() {
        setSlideWidths();
        if (embla) {
          embla.reInit(getEmblaOptions());
        }
      }, 150);

      if (prevButton$) {
        prevButton$.addEventListener('click', function() { embla.scrollPrev(); });
      }

      if (nextButton$) {
        nextButton$.addEventListener('click', function() { embla.scrollNext(); });
      }

      window.addEventListener('resize', handleResize);
    });
  };

  initCarousels();
});
